const descriptions = {
  HEARING_LOSS:
    'Your level of hearing loss is used to determine the best type of hearing aid for you.',
  AGE:
    'Your age group is used to control which features are available for your iHear device.',
  GENDER: 'You gender is used to select default values for some features.',
  COLOR:
    'Personalize your iHear by choosing one of the following colors for your hearing aid.',
  STYLE:
    'The shape and placement of your iHear determine what features will be available.',
  PUSH_BUTTON:
    'The push buttons are used to control certain features on your iHear hearing aid.',
  MICROPHONES: 'The microphone records the sound and amplifies it in your ear.',
  POWER_LEVEL:
    'The power level determines how much the hearing aid can amplify the sound.',
  CPUS:
    'The number of CPUs is related to the features you can add to your iHear.',
  RAM:
    'The amount of memory is also related to the features you can add to your iHear.',
  BATTERY_SIZE:
    'The size of the battery determines how many hours your iHear runs before needing new batteries.',
  BATTERY_DRAWER:
    'The orientation of the battery drawer influences the type of microphones you can choose.',
  BATTERY_DRAWER_TYP:
    'The battery drawer can be equipped with a tamper resistant lock.',
  AUTOPHONE:
    'The auto-phone feature automatically connects to your mobile phone on incoming calls.',
  AUTOTELECOIL:
    'The auto-telecoil feature automatically connects the telecoil to an external signal.',
  BINAURAL:
    'Binaural hearing enables wireless communication between the left and the right hearing aid.',
  MUSIC:
    'Choose this option if you want to stream music directly from your mobile phone via Bluetooth.',
  SOUND:
    'This feature specifies the quality of the sound processing system in the hearing aid.',
  SPATIAL:
    'Spatial sound provides a richer sound experience with 3D directionality.',
  WIRELESS_COIL:
    'A wireless coil enables your iHear to communicate with other devices wirelessly.',
  TELECOIL:
    'A telecoil is an antenna for your ears, receiving magnetic waves and converting them to sound.',
  SWITCHES:
    'The switches are used to automatically turn on features of your iHear, e.g., auto-phone.',
  VOLUME_WHEEL:
    'The volume wheel is used to manally control the sound level of your iHear.',
  AP: 'Software module required for the auto-phone feature.',
  AT: 'Software module required for the auto-telecoil feature.',
  BIN: 'Software module required for the binaural hearing feature.',
  DIR: 'Software module required for the directional hearing feature.',
  MUS: 'Software module required for the music streaming feature.',
  SPA: 'Software module required for the spatial sound feature.',
  DSP: 'Software module required for the digital sound processor (DSP).'
};

export default descriptions;
